<template>
  <div class="project-structure-frame" id="project-structure-frame">


    <div class="project-structure-frame-content">

      <!-- <div class="project-structure-frame-content-header" style="border: 1px solid red">
        <slot name="project-structure-header" />
      </div> -->

      <!-- THREE COLUMNS -->
      <SplitableResizeContainer id="project-structure-frame-content-body" width="100%" height="100%"
        direction="row" :children="[
          { minimize: 'left', size: '20%', min_size: 100, max_size: 600 },
          { minimize: false, size: '60%' },
          { minimize: 'right', size: '20%', min_size: 100, max_size: 600 },
        ]">
        <!-- LEFT -->
        <template #slot-1>
          <SplitableResizeContainer id="project-structure-frame-content-left" width="100%" height="100%"
            direction="column" :children="[
              { minimize: 'left', size: '20%', min_size: 70 },
              { minimize: 'right', size: '60%', min_size: 60},
              // { minimize: false, size: '10%', min_size: 1 },
              { minimize: 'right', size: '20%', min_size: 48 }, //details

            ]">
            <template #slot-1>
              <slot name="content-left-top" />
            </template>
            <template #slot-2>
              <slot name="content-left-center" />
            </template>
            <template #slot-3="{child, resize_id}">
              <slot name="content-left-bottom" :child="child" :resize_id="resize_id"/>
            </template>
          </SplitableResizeContainer>
        </template>
        <!-- CENTER -->
        <template #slot-2>
          <SplitableResizeContainer id="project-structure-frame-content-center" width="100%" height="100%"
            direction="column" :children="[
              { minimize: false, size: '80%' },
              { minimize: 'right', size: '20%', min_size: 50 },
            ]">
            <template #slot-1>
              <slot name="content-center-top" />
            </template>
            <template #slot-2>
              <slot name="content-center-bottom" />
            </template>
          </SplitableResizeContainer>
        </template>
        <!-- RIGHT -->
        <template #slot-3>
          <SplitableResizeContainer id="project-structure-frame-content-right" width="100%" height="100%"
            direction="column" :children="[
              { minimize: 'left', size: '20%', min_size: 70 },
              { minimize: 'right', size: '60%', min_size: 60 },
              { minimize: 'right', size: '20%', min_size: 48 }, // details
            ]">
            <template #slot-1>
              <slot name="content-right-top" />
            </template>
            <template #slot-2>
              <slot name="content-right-center" />
            </template>
            <template #slot-3="{child, resize_id}">
              <slot name="content-right-bottom" :child="child" :resize_id="resize_id"/>
            </template>
          </SplitableResizeContainer>
        </template>
      </SplitableResizeContainer>
    </div>
  </div>
</template>

<script>
import SplitableResizeContainer from '@/components/ProjectStructureRework/SplitableResizeContainer.component.vue';

export default {
  props: [],
  data: () => ({
  }),
  components: {
    SplitableResizeContainer
  }
}
</script>
<style>
/* 'hp-color-drk-b07': '#B9b3ff',
  'hp-color-drk-b06': '#a7a1e6',  
  'hp-color-drk-b05': '#948fcc',  
  'hp-color-drk-b04': '#827db3',  
  'hp-color-drk-b03': '#6f6b99',  
  'hp-color-drk-b02': '#5d5980',  
  'hp-color-drk-b01': '#4a4766',  
  'hp-color-drk-b00': '#2e2c40', */




.hp-color-drk-b07 {
  background-color: #B9b3ff;
}

.hp-color-drk-b06 {
  background-color: #a7a1e6;
}

.hp-color-drk-b05 {
  background-color: #948fcc;
}

.hp-color-drk-b04 {
  background-color: #827db3;
}

.hp-color-drk-b03 {
  background-color: #6f6b99;
}

.hp-color-drk-b02 {
  background-color: #5d5980;
}

.hp-color-drk-b01 {
  background-color: #4a4766;
}

.hp-color-drk-b00 {
  background-color: #2e2c40;
}



.project-structure-frame {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 5px;
  /* background: radial-gradient(circle, #BEAECF 0%, #99C0C8 20%, #7A97AE 60%, #6B73A7 80%, #53528A 100%); */
  /* background-color: red; */
  /* border: 1px solid white; */
  /* overflow: hidden; */
  pointer-events: none;
  /* Fix: Canvas Interaction */
}

.project-structure-frame-background {
  position: absolute;
  background-position: center;
  background-attachment: fixed;
  width: 100%;
  height: 100%;
  /* background-color: blue; */
  /* border: 1px solid white; */
  overflow: hidden;
  /* ist für den fix vom canvas */
  /* background: radial-gradient(circle, #BEAECF 0%, #99C0C8 20%, #7A97AE 60%, #6B73A7 80%, #53528A 100%); */
  /* canvas background wird in 3JS definiert */
}

.project-structure-frame-content-header {
  /* border: 1px solid white; */
  width: 100%;
  height: 60px;
  z-index: 110;
  display: flex;

  position: relative;
  flex-direction: row;
  justify-content: center;
}

.project-structure-frame-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  /* pointer-events: none; */
}
</style>
  